export default "__VITE_ASSET__49cfca36__"